export default __webpack_public_path__ + "static/media/328.0d7a598c.jpg";